// extracted by mini-css-extract-plugin
export default {"loader-overlay":"CustomLoader_loader-overlay__NehEd","loader-container":"CustomLoader_loader-container__PWk1B"};